export default {
  // Basic info
  'agents.title': 'Agents',
  'agents.tab.ai': 'AI',
  'agents.tab.rpa': 'RPA',
  'agents.tab.skills': 'Skills',

  // AI Provider options (for filters and forms)
  'agents.ai.provider.openai': 'OpenAI',

  // RPA Platform options (for filters and forms)
  'agents.rpa.platform.windows': 'Windows',
  'agents.rpa.platform.android': 'Android',

  // RPA effective status (derived from isActive + current session)
  'agents.rpa.status.unknown': 'Unknown',
  'agents.rpa.status.online': 'Online',
  'agents.rpa.status.offline': 'Offline',
  'agents.rpa.status.disabled': 'Disabled',
  'agents.rpa.status.unlinked': 'No device linked',
  'agents.rpa.status.created': 'Waiting for connection',
  'agents.rpa.sessionEndReason.replacedbyanotherinstallation': 'Replaced by another device',
  'agents.rpa.sessionEndReason.installationreassigned': 'Device reassigned to another agent',
  'agents.rpa.sessionEndReason.manuallyrevoked': 'Manually unlinked',
  'agents.rpa.sessionEndReason.agentdisabled': 'Agent disabled',

  // Buttons
  'agents.button.interact': 'Interact',
  'agents.button.builder': 'Builder',

  // Form field translations
  'agents.form.provider': 'Provider',
  'agents.form.model': 'Model',
  'agents.form.connections': 'Connections',
  'agents.form.connections.connection': 'Connection',
  'agents.form.triggers': 'Triggers',
  'agents.form.triggers.hint':
    'Draft changes are saved on the version only. Graph subscriptions are provisioned when you publish.',
  'agents.form.triggers.connectionInUse':
    'A connection is still used by a trigger. Remove or reassign the trigger before removing the connection.',
  'agents.form.triggers.type': 'Type',
  'agents.form.triggers.type.graph-email-received': 'Graph email received',
  'agents.form.triggers.type.agent-email-received': 'Agent mailbox email',
  'agents.form.triggers.type.email-received': 'Graph email received',
  'agents.form.triggers.connection': 'Mailbox connection',
  'agents.form.triggers.connectionId': 'Mailbox connection',
  'agents.form.triggers.enabled': 'Enabled',
  'agents.form.triggers.folderId': 'Folder',
  'agents.form.triggers.folderId.placeholder': 'Empty = Inbox',
  'agents.form.triggers.fromFilters': 'From',
  'agents.form.triggers.fromFilters.placeholder': 'Type an email and press Enter',
  'agents.form.triggers.subjectFilters': 'Subject',
  'agents.form.triggers.subjectFilters.placeholder': 'Type text and press Enter',
  'agents.form.triggers.subjectComparisonOperator': 'Subject comparison',
  'agents.form.triggers.subjectComparisonOperator.equal': 'Equals',
  'agents.form.triggers.subjectComparisonOperator.contains': 'Contains',
  'agents.form.triggers.hasAttachmentsFilter': 'Only emails with attachments',
  'agents.form.triggers.hasAttachmentsFilter.help':
    'Graph only delivers messages that include attachments.',
  'agents.form.triggers.includeAttachments': 'Download attachments',
  'agents.form.triggers.includeAttachments.help':
    'When on, the agent downloads non-inline attachments while processing the email.',
  'agents.form.triggers.onlyAutomyUsers': 'Only Automy senders',
  'agents.form.triggers.onlyAutomyUsers.help':
    'Continue only if the sender matches an active company user.',
  'agents.form.triggers.validateAgentAccess': 'Validate agent access',
  'agents.form.triggers.validateAgentAccess.help':
    'Requires the Automy sender to be allowed to use this agent. Needs “Only Automy senders”.',
  'agents.form.triggers.impersonateUser': 'Impersonate sender',
  'agents.form.triggers.impersonateUser.help':
    'If the sender is an Automy user, the new chat is owned by that user.',
  'agents.form.triggers.participants': 'Chat participants',
  'agents.form.triggers.connection.empty':
    'Add an Azure Graph connection under Connections to pick a mailbox.',
  'agents.form.triggers.validateAgentAccess.requiresOnlyAutomyUsers':
    'Validate agent access requires “Only Automy senders”.',
  'agents.form.allowedRoles': 'Role Configuration',
  'agents.form.allowedRoles.allowed': 'Allowed Roles',
  'agents.form.allowedRoles.denied': 'Denied Roles',
  'agents.form.memory': 'Memory',
  'agents.form.team': 'Team',
  'agents.form.email': 'Email',
  'agents.form.username': 'Username',
  'agents.form.domains': 'Domains',
  'agents.form.longDescription': 'Long Description',
  'agents.form.instructions': 'Instructions',
  'agents.form.instructions.edit': 'Edit Instructions',
  'agents.form.instructions.placeholder.expanded':
    'Write detailed instructions for your AI agent...',
  'agents.form.icon': 'Icon',
  'agents.form.isActive': 'Active',
  'agents.form.deviceName': 'Device Name',
  'agents.form.ip': 'IP Address',
  'agents.form.ip.error': 'Please enter a valid IP address',
  'agents.form.skills': 'Skills',
  'agents.form.skills.skill': 'Skill',
  'agents.form.vectors': 'Vectors',
  'agents.form.vectors.vector': 'Vector',
  'agents.form.collaborators.collaborator': 'Collaborator',

  // Configuration translations
  'agents.form.configurations.greetings': 'Greetings',
  'agents.form.configurations.greetings.message': 'Message',
  'agents.form.configurations.greetings.message.edit': 'Edit Greeting Message',
  'agents.form.configurations.greetings.message.placeholder':
    'Write the greeting message for this language...',
  'agents.form.configurations.searchingHumanAgentMessages': 'Searching Human Agent Messages',
  'agents.form.configurations.searchingHumanAgentMessages.message': 'Message',
  'agents.form.configurations.searchingHumanAgentMessages.message.edit': 'Edit Search Message',
  'agents.form.configurations.searchingHumanAgentMessages.message.placeholder':
    'Write the human agent search message for this language...',
  'agents.form.configurations.trainingVectors': 'Training Vectors',
  'agents.form.configurations.reasoningEffort': 'Reasoning Effort',
  'agents.form.configurations.reasoningEffort.none': 'None',
  'agents.form.configurations.reasoningEffort.minimal': 'Minimal',
  'agents.form.configurations.reasoningEffort.low': 'Low',
  'agents.form.configurations.reasoningEffort.medium': 'Medium',
  'agents.form.configurations.reasoningEffort.high': 'High',
  'agents.form.configurations.reasoningSummary': 'Reasoning Summary',
  'agents.form.configurations.reasoningSummary.concise': 'Concise',
  'agents.form.configurations.reasoningSummary.detailed': 'Detailed',
  'agents.form.configurations.reasoningSummary.auto': 'Auto',
  'agents.form.configurations.allowedTools': 'Allowed Tools',
  'agents.form.configurations.allowedTools.codeinterpreter': 'Code Interpreter',
  'agents.form.configurations.allowedTools.codeinterpreter.description':
    'Runs Python code in a sandbox for computations, data analysis and chart generation.',
  'agents.form.configurations.allowedTools.filesearch': 'File Search',
  'agents.form.configurations.allowedTools.filesearch.description':
    'Queries and retrieves information from files attached to the agent.',
  'agents.form.configurations.allowedTools.websearch': 'Web Search',
  'agents.form.configurations.allowedTools.websearch.description':
    'Searches the Internet for up-to-date information so the agent can answer with real-time data.',
  'agents.form.configurations.allowedTools.imagegeneration': 'Image Generation',
  'agents.form.configurations.allowedTools.imagegeneration.description':
    'Generates images from natural-language descriptions.',
  'agents.form.configurations.allowedTools.mcp': 'MCP',
  'agents.form.configurations.allowedTools.mcp.description':
    'Connects the agent to external MCP servers for remote tools and data sources.',
  'agents.form.configurations.allowedTools.function': 'Function',
  'agents.form.configurations.allowedTools.function.description':
    'Lets the agent invoke custom functions declared by the system.',
  'agents.form.configurations.allowedTools.shell': 'Shell',
  'agents.form.configurations.allowedTools.shell.description':
    'Executes terminal commands in a sandboxed environment to automate system tasks.',
  'agents.form.configurations.allowedTools.automyinternalmcp': 'Internal Tools',
  'agents.form.configurations.allowedTools.automyinternalmcp.description':
    "Enables Automy's built-in tools: processes, lists, entities and platform actions.",
  'agents.form.configurations.allowedTools.automyinternalfunctionaitodo': 'Plan ToDo',
  'agents.form.configurations.allowedTools.automyinternalfunctionaitodo.description':
    'Lets the agent create task ToDos to plan and track long-running operations by breaking them into steps.',
  'agents.form.configurations.allowedTools.automyinternalfunctionfileresources': 'File Resources',
  'agents.form.configurations.allowedTools.automyinternalfunctionfileresources.description':
    'Lets the agent prepare and make file resources available so they can be used during the conversation.',
  'agents.form.configurations.allowedTools.automyinternalfunctionmediaprepareupload':
    'Prepare Media Upload',
  'agents.form.configurations.allowedTools.automyinternalfunctionmediaprepareupload.description':
    'Consolidates a file already generated in the code interpreter into durable Automy media and returns a permanent public URL.',
  'agents.form.configurations.guardrails.title': 'Guardrails',
  'agents.form.configurations.guardrails.moderation.enabled': 'Moderation Options Enabled',
  'agents.form.configurations.guardrails.pii.enabled': 'PII Options Enabled',
  'agents.form.configurations.guardrails.pii.rules': 'PII Rules',
  'agents.form.configurations.guardrails.pii.rules.entity': 'Entity',
  'agents.form.configurations.guardrails.pii.rules.entity.creditcard': 'Credit Card',
  'agents.form.configurations.guardrails.pii.rules.entity.email': 'Email',
  'agents.form.configurations.guardrails.pii.rules.entity.phone': 'Phone',
  'agents.form.configurations.guardrails.pii.rules.entity.ipaddress': 'IP Address',
  'agents.form.configurations.guardrails.pii.rules.entity.ibancode': 'IBAN Code',
  'agents.form.configurations.guardrails.pii.rules.entity.url': 'URL',
  'agents.form.configurations.guardrails.pii.rules.entity.usbanknumber': 'US Bank Number',
  'agents.form.configurations.guardrails.pii.rules.entity.usitin': 'US ITIN',
  'agents.form.configurations.guardrails.pii.rules.entity.uspassport': 'US Passport',
  'agents.form.configurations.guardrails.pii.rules.entity.usssn': 'US SSN',
  'agents.form.configurations.guardrails.pii.rules.entity.pedni': 'PE DNI',
  'agents.form.configurations.guardrails.pii.rules.entity.peruc': 'PE RUC',
  'agents.form.configurations.guardrails.pii.rules.entity.pepassport': 'PE Passport',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountnumber':
    'PE Bank Account Number',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountcci': 'PE Bank Account CCI',
  'agents.form.configurations.guardrails.pii.rules.action': 'Action',
  'agents.form.configurations.guardrails.pii.rules.action.mask': 'Mask',
  'agents.form.configurations.guardrails.pii.rules.action.pseudonymize': 'Pseudonymize',
  'agents.form.configurations.guardrails.pii.rules.action.tokenizereversible':
    'Tokenize Reversible',
  'agents.form.configurations.guardrails.pii.rules.action.remove': 'Remove',
  'agents.form.configurations.guardrails.pii.rules.action.keep': 'Keep',
  'agents.form.configurations.guardrails.pii.rules.maskChar': 'Mask Character',
  'agents.form.configurations.guardrails.pii.rules.keepPrefix': 'Keep Prefix',
  'agents.form.configurations.guardrails.pii.rules.keepSuffix': 'Keep Suffix',
  'agents.form.configurations.guardrails.urlFilter.enabled': 'URL Filter Options Enabled',
  'agents.form.configurations.guardrails.urlFilter.action': 'Action',
  'agents.form.configurations.guardrails.urlFilter.action.block': 'Block',
  'agents.form.configurations.guardrails.urlFilter.action.mask': 'Mask',
  'agents.form.configurations.guardrails.urlFilter.action.warn': 'Warn',
  'agents.form.configurations.guardrails.urlFilter.mode': 'Mode',
  'agents.form.configurations.guardrails.urlFilter.mode.allowlist': 'Allow List',
  'agents.form.configurations.guardrails.urlFilter.mode.denylist': 'Deny List',
  'agents.form.configurations.guardrails.urlFilter.allowedDomains': 'Allowed Domains',
  'agents.form.configurations.guardrails.urlFilter.blockedDomains': 'Blocked Domains',
  'agents.form.configurations.guardrails.urlFilter.blockedRegex': 'Blocked Patterns (Regex)',
  'agents.form.configurations.guardrails.urlFilter.domain': 'Domain',
  'agents.form.configurations.guardrails.urlFilter.pattern': 'Pattern',
  'agents.form.configurations.guardrails.urlFilter.allowIpHosts': 'Allow IP Hosts',
  'agents.form.configurations.guardrails.urlFilter.allowedSchemes': 'Allowed Schemes',
  'agents.form.configurations.guardrails.urlFilter.scheme': 'Scheme',
  'agents.form.configurations.guardrails.urlFilter.maxUrls': 'Max URLs',
  'agents.form.configurations.guardrails.urlFilter.blockUrlShorteners': 'Block URL Shorteners',
  'agents.form.configurations.guardrails.urlFilter.urlShortenerDomains': 'URL Shortener Domains',
  'agents.form.configurations.guardrails.jailbreak.enabled': 'Jailbreak Options Enabled',
  'agents.form.configurations.guardrails.jailbreak.model': 'Model',
  'agents.form.configurations.guardrails.jailbreak.blockConfidence': 'Block Confidence',
  'agents.form.configurations.guardrails.pii.title': 'Personally identifiable information',
  'agents.form.configurations.guardrails.pii.help':
    'Masks or removes personal data from the message before the agent reads it.',
  'agents.form.configurations.guardrails.urlFilter.title': 'URL filter',
  'agents.form.configurations.guardrails.urlFilter.help':
    'Checks links in the message before the other content checks.',
  'agents.form.configurations.guardrails.moderation.title': 'Moderation',
  'agents.form.configurations.guardrails.moderation.help':
    'Blocks messages that match the configured content categories.',
  'agents.form.configurations.guardrails.jailbreak.title': 'Jailbreak',
  'agents.form.configurations.guardrails.jailbreak.help':
    'Detects attempts to override the agent instructions. Runs on the message text.',
  'agents.form.configurations.guardrails.customPrompt.title': 'Custom policy',
  'agents.form.configurations.guardrails.customPrompt.help':
    'Flags messages that match the criteria you write. This is not the agent prompt.',
  'agents.form.configurations.guardrails.customPrompt.enabled': 'Custom policy',
  'agents.form.configurations.guardrails.customPrompt.criteria': 'Criteria to flag',
  'agents.form.configurations.guardrails.promptInjection.title': 'Prompt injection',
  'agents.form.configurations.guardrails.promptInjection.help':
    'Checks proposed actions and function results before they continue. Not compatible with remote MCP.',
  'agents.form.configurations.guardrails.promptInjection.enabled': 'Prompt injection',
  'agents.form.configurations.guardrails.promptInjection.mcpIncompatible':
    'Prompt injection is not compatible with remote MCP',
  'agents.form.configurations.guardrails.hallucination.title': 'Document check',
  'agents.form.configurations.guardrails.hallucination.help':
    'Checks the final answer against an authorized document source.',
  'agents.form.configurations.guardrails.hallucination.enabled': 'Document check',
  'agents.form.configurations.guardrails.hallucination.vector': 'Document source',
  'agents.form.configurations.guardrails.hallucination.knowledgeSource': 'OpenAI vector store id',
  'agents.form.configurations.guardrails.llm.model': 'Model',
  'agents.form.configurations.guardrails.llm.confidencePercent': 'Confidence threshold (%)',
  'agents.form.configurations.guardrails.llm.maxTurns': 'User turns to review',
  'agents.form.configurations.guardrails.llm.includeReasoning': 'Include classifier diagnostic',
  'agents.form.configurations.guardrails.continueOnError': 'Continue on error',
  'agents.form.configurations.guardrails.continueOnError.help':
    'If a security check fails technically, the turn continues and the failure stays visible. A detected violation still blocks the turn.',
  'agents.form.configurations.guardrails.configure': 'Configure check',
  'agents.form.configurations.guardrails.validation.hallucinationSource':
    'The document check needs an authorized source',

  // Tabs
  'agents.tabs.general': 'General',
  'agents.tabs.configurations': 'Configurations',

  // Wizard steps
  'agents.wizard.steps.basicInformation': 'Basic Information',
  'agents.wizard.steps.technicalConfiguration': 'Technical Configuration',
  'agents.wizard.steps.permissions': 'Permissions',
  'agents.wizard.steps.advancedConfigurationAndContent': 'Advanced Configuration and Content',
  'agents.wizard.steps.guardrails': 'Guardrails',

  // Global translations
  'global.text.configuration': 'Configuration',

  // Agent Builder
  'agentBuilder.title': 'New agent',
  'agentBuilder.sidebar.overview': 'Overview',
  'agentBuilder.token.error.title': 'Versioned configuration unavailable',
  'agentBuilder.token.error.description':
    'Could not issue an edit token for this version. Changes to instructions, skills, connections, permissions, access control, greetings, training vectors and guardrails won\u2019t be saved until the connection recovers. Basic agent metadata (name, model, description) can still be edited.',
  'agentBuilder.panel.saving': 'Saving…',
  'agentBuilder.header.openChat': 'Open chat',
  'agentBuilder.chat.title': 'AI Assistant',
  'agentBuilder.chat.open': 'Open chat',
  'agentBuilder.chat.close': 'Close chat',
  'agentBuilder.error.notFound': 'The requested agent could not be loaded.',
  'agentBuilder.unsaved.indicator': 'Unsaved changes',
  'agentBuilder.unsaved.confirm':
    'You have unsaved changes. Are you sure you want to leave and discard them?',
  'agentBuilder.save.error': 'Unable to save the agent changes.',
  'agentBuilder.card.unnamed': 'Unnamed agent',
  'agentBuilder.card.noModel': 'No model',
  'agentBuilder.card.restricted': 'Restricted',
  'agentBuilder.card.itemsCount': '{count, plural, =0 {No items} one {# item} other {# items}}',
  'agentBuilder.newAgent.title': 'New AI agent',
  'agentBuilder.newAgent.subtitle': 'Set the basic identity. Complete the rest in the builder.',
  'agentBuilder.newAgent.continue': 'Continue',
  'agentBuilder.newAgent.name.placeholder': 'e.g. Sales assistant',
  'agentBuilder.newAgent.email.placeholder': 'sales@agent.automy.global',
  'agentBuilder.newAgent.description.placeholder': 'What does this agent do? Who does it help?',
  'agentBuilder.card.active': 'Active',
  'agentBuilder.card.inactive': 'Inactive',
  'agentBuilder.card.public': 'Public',
  'agentBuilder.card.private': 'Private',
  'agentBuilder.card.configure': 'Configure',
  'agentBuilder.card.empty': 'Not configured',
  'agentBuilder.card.configured': 'Configured',
  'agentBuilder.card.stats.permissions':
    '{count, plural, =0 {No permissions} one {# permission} other {# permissions}}',
  'agentBuilder.card.stats.greetings':
    '{count, plural, =0 {No greetings} one {# greeting} other {# greetings}}',
  'agentBuilder.card.stats.guardrails':
    '{count, plural, =0 {No guardrails} one {# active guardrail} other {# active guardrails}}',
  'agentBuilder.card.stats.skills':
    '{count, plural, =0 {No skills} one {# skill} other {# skills}}',
  'agentBuilder.card.stats.connections':
    '{count, plural, =0 {No connections} one {# connection} other {# connections}}',
  'agentBuilder.card.stats.triggers':
    '{count, plural, =0 {No triggers} one {# trigger} other {# triggers}}',
  'agentBuilder.card.stats.escalations':
    '{count, plural, =0 {No escalations} one {# escalation} other {# escalations}}',
  'agentBuilder.card.stats.guardrailsRatio': '{active}/{total} active',
  'agentBuilder.card.noDescription': 'Add a description so your team knows how to use this agent.',
  'agentBuilder.section.general': 'General',
  'agentBuilder.section.brain': 'Brain',
  'agentBuilder.section.brain.subtitle':
    "Define the agent's core intelligence: instructions, knowledge and tools it uses to reason.",
  'agentBuilder.instructions.title': 'System instructions',
  'agentBuilder.instructions.subtitle':
    'Tell the agent who it is, what it should do and how to behave.',
  'agentBuilder.instructions.placeholder':
    'You are a helpful assistant that…\n\nDescribe the agent’s role, its goals, the tone it should use and any rules or constraints it must follow.',
  'agentBuilder.instructions.words': '{count} words',
  'agentBuilder.instructions.chars': '{count} characters',
  'agentBuilder.instructions.expand': 'Expand editor',
  'agentBuilder.instructions.done': 'Done',
  'agentBuilder.instructions.template': 'Insert template',
  'agentBuilder.instructions.toolbarLabel': 'Structure',
  'agentBuilder.instructions.hint':
    'Be specific: define the role, goals and constraints. Good instructions dramatically improve responses.',
  'agentBuilder.instructions.section.role': 'Role & objective',
  'agentBuilder.instructions.section.context': 'Context',
  'agentBuilder.instructions.section.instructions': 'Instructions',
  'agentBuilder.instructions.section.constraints': 'Constraints',
  'agentBuilder.instructions.section.tone': 'Tone & style',
  'agentBuilder.instructions.section.format': 'Output format',
  'agentBuilder.instructions.tipsTitle': 'Tips for great instructions',
  'agentBuilder.instructions.tip1':
    "Start by defining the agent's role and main objective in one clear sentence.",
  'agentBuilder.instructions.tip2':
    'Break guidance into short sections and use lists for steps or rules.',
  'agentBuilder.instructions.tip3':
    'Explicitly state what it should NOT do and how to handle ambiguous cases.',
  'agentBuilder.instructions.tip4':
    'Specify the tone, language and expected output format (text, list, JSON…).',
  'agentBuilder.card.reasoning.summary.placeholder': 'No summary',
  'agentBuilder.card.reasoning.effort.short': 'Effort',
  'agentBuilder.card.reasoning.summary.short': 'Summary',
  'agentBuilder.section.permissions': 'Permissions',
  'agentBuilder.section.behavior': 'Behavior',
  'agentBuilder.section.guardrails': 'Guardrails',
  'agentBuilder.card.trainingDocs': 'Training documents',
  'agentBuilder.card.stats.trainingDocs':
    '{count, plural, =0 {No documents} one {# document} other {# documents}}',

  // Versions & publish (versioned config flow)
  'agentBuilder.version.createdBy': 'Created by',
  'agentBuilder.version.createdDate': 'Created on',
  'agentBuilder.version.publishedBy': 'Published by',
  'agentBuilder.version.publishedDate': 'Published on',
  'agentBuilder.version.current': 'current',
  'agentBuilder.version.error': 'Could not switch to the selected version.',
  'agentBuilder.publish': 'Publish',
  'agentBuilder.published': 'Published',
  'agentBuilder.publish.success': 'Version published successfully.',
  'agentBuilder.publish.error': 'Could not publish this version.',
  'agentBuilder.publish.forceButton': 'Publish anyway',
  'agentBuilder.publish.inconsistencies.title': 'Review warnings before publishing',
  'agentBuilder.publish.inconsistencies.intro':
    'The agent can be published, but the internal summary detected issues that may affect how tools and resources are routed in chat.',
  'agentBuilder.publish.inconsistencies.hint':
    'If you publish anyway, the orchestrator may route tools or resources sub-optimally until you fix the configuration and publish again.',
  'agentBuilder.setCurrent': 'Set as current',
  'agentBuilder.setCurrent.success': 'Version set as current successfully.',
  'agentBuilder.setCurrent.error': 'Error setting version as current.',
  'agentBuilder.setCurrent.tooltip':
    'This published version will become the one the agent uses in production.',
  'agentBuilder.publish.tooltip.readOnly':
    'This version is already published. Switch to a draft version to edit.',
  'agentBuilder.readonly.cantEdit': 'Cannot edit a published version.',
  'agentBuilder.card.accessControl.public': 'Visible to everyone',
  'agentBuilder.card.accessControl.restricted':
    '{count, plural, =0 {No access configured} one {Restricted access (# entity)} other {Restricted access (# entities)}}',

  // Sidebar entries
  'agentBuilder.sidebar.traces': 'Traces',
  'agentBuilder.sidebar.dependencies': 'Dependencies',

  // Traces
  'agentBuilder.traces.title': 'Configuration traces',
  'agentBuilder.traces.empty': 'No traces yet for this version.',
  'agentBuilder.traces.column.operation': 'Operation',
  'agentBuilder.traces.column.elementType': 'Element',
  'agentBuilder.traces.column.creator': 'User',
  'agentBuilder.traces.column.created': 'Date',
  'agentBuilder.traces.column.data': 'Detail',
  'agentBuilder.traces.operation.generate-token-readonly': 'Read token',
  'agentBuilder.traces.operation.generate-token-write': 'Write token',
  'agentBuilder.traces.operation.append-component': 'Append component',
  'agentBuilder.traces.operation.modify-component': 'Modify component',
  'agentBuilder.traces.operation.remove-component': 'Remove component',
  'agentBuilder.traces.operation.publish': 'Publish',
  'agentBuilder.traces.operation.new-version-created': 'New version',
  'agentBuilder.traces.operation.change-current-version': 'Change current version',

  // Dependencies
  'agentBuilder.dependencies.title': 'Dependencies',
  'agentBuilder.dependencies.empty':
    'This agent has no declared dependencies in the current configuration.',
  'agentBuilder.dependencies.column.entity': 'Entity',
  'agentBuilder.dependencies.column.type': 'Type',
  'agentBuilder.dependencies.column.name': 'Name',

  // EntitySelector keys live in src/locales/{lang}/component.js (shared globally)
};
